import keyMirror from 'keymirror-nested'

export default keyMirror({
  MODAL: {
    UPDATE: null,
    CREATING_SHIPMENT: null,
  },
})
